import { render, staticRenderFns } from "./UserContainer.vue?vue&type=template&id=55425dba&scoped=true"
import script from "./UserContainer.vue?vue&type=script&lang=js"
export * from "./UserContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55425dba",
  null
  
)

export default component.exports